import React from 'react';
import { Box, styled, Typography } from '@mui/material';

const StyledWrapper = styled(Box)(({ theme }) => ({
    padding: "10px 0 10px 0",
    marginBottom: "3px"
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: "#999999"
}));


export const Breadcrumb = () => {

    return (
        <StyledTypography>
            Főoldal
        </StyledTypography>
    );
};
